'use client';

import { useToast } from '@common/hooks';
import { CustomError } from '@core/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AuthApi, AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

//* 혜택알림(=마케팅 수신동의)을 켜는 공용 뮤테이션. master + 3채널(앱푸시·이메일·SMS)을
//* 함께 켜 /my/settings/notifications 및 출석 알림받기와 동의 상태를 일치시킨다.
const MARKETING_CONSENT = {
  marketingMessageReceiveYN: true,
  marketingMessageAppPushReceiveYN: true,
  marketingMessageEmailReceiveYN: true,
  marketingMessageMobileReceiveYN: true,
} as const;

export const useAcceptMarketingConsent = () => {
  const setMyInfo = useAuthStore((state) => state.setMyInfo);
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const profileQueryKey =
    AuthQueryOptions['get:/wello/v2/auth/member/profile']().queryKey;

  return useMutation({
    mutationFn: () => {
      const current = useAuthStore.getState().myInfo;
      if (!current) {
        throw new CustomError({
          return_message: '내 정보를 불러오지 못했습니다.',
        });
      }

      return AuthApi['put:/wello/v2/auth/member/message-receive']({
        body: { ...current.notificationOptions, ...MARKETING_CONSENT },
      });
    },
    onSuccess: () => {
      const current = useAuthStore.getState().myInfo;
      if (!current) {
        return;
      }

      setMyInfo({
        ...current,
        notificationOptions: {
          ...current.notificationOptions,
          ...MARKETING_CONSENT,
        },
      });
    },
    onError: () => {
      toast({
        message: '동의 처리에 실패했어요. 다시 시도해 주세요.',
        type: 'fail',
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: profileQueryKey }),
  });
};
